import { useQuery } from '@tanstack/react-query'
import { listTaxons } from '../api/taxons'
import { QUERY_KEYS } from '../constants/query'
import { toApiMessage } from '../helpers/api-error'
import {
  mapCategoryTiles,
  mapNavCategories,
  type CategoryTile,
  type NavCategory,
} from '../helpers/mapCatalog'

type NavCategoriesState = {
  categories: NavCategory[]
  tiles: CategoryTile[]
  loading: boolean
  error: string | null
}

export function useNavCategories(): NavCategoriesState {
  const taxonsQuery = useQuery({
    queryKey: QUERY_KEYS.taxons(true),
    queryFn: () => listTaxons(true),
  })
  const rows = taxonsQuery.data ?? []
  const error = taxonsQuery.error
    ? toApiMessage(taxonsQuery.error, 'Failed to load categories')
    : null

  return {
    categories: mapNavCategories(rows),
    tiles: mapCategoryTiles(rows),
    loading: taxonsQuery.isPending && !taxonsQuery.data && !error,
    error,
  }
}
